import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import TextField from '@afosto/app-components-react/TextField';
import Form from '@afosto/app-components-react/Form';
import validationSchema from './validations';
import translations from './translations';

const EditProfileForm = ({ user, onSubmit, onCancel }) => {
  const intl = useIntl();
  const { firstName = '', lastName = '', email = '' } = user || {};

  const form = useForm({
    validationSchema,
    editInline: false,
    defaultValues: {
      firstName,
      lastName,
      email,
    },
    onCancel,
    onSubmit,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField
          name="firstName"
          label={intl.formatMessage(translations.fields.firstName.label)}
          autoFocus
        />
        <TextField name="lastName" label={intl.formatMessage(translations.fields.lastName.label)} />
        <TextField
          name="email"
          label={intl.formatMessage(translations.fields.email.label)}
          readOnly
          inline
        />
      </Form>
    </LoadingWrapper>
  );
};

EditProfileForm.propTypes = {
  user: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

EditProfileForm.defaultProps = {
  user: null,
  onSubmit: undefined,
  onCancel: undefined,
};

export default EditProfileForm;
